import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';

export interface ZoneInspectionAssignmentDto {
  id: string;
  organizationMemberId: string;
  zoneId: string;
  inspectionDefinitionId: string;
  shiftId?: string;
  shiftName?: string;
  organizationMemberName: string;
  organizationMemberEmail: string;
}

export interface UpdateZoneInspectionAssignmentsRequest {
  zoneId: string;
  inspectionDefinitionId: string;
  shiftId?: string;
  organizationMemberIds: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ZoneInspectionAssignmentsHttpService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_BASE) private readonly apiBase: string
  ) {}

  getAssignmentsByZone(zoneId: string, inspectionDefinitionId?: string, shiftId?: string): Observable<ZoneInspectionAssignmentDto[]> {
    let url = `${this.apiBase}/organizations/zone-inspection-assignments/${zoneId}`;
    const params = [];
    if (inspectionDefinitionId) {
      params.push(`inspectionDefinitionId=${inspectionDefinitionId}`);
    }
    if (shiftId) {
      params.push(`shiftId=${shiftId}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.http.get<ZoneInspectionAssignmentDto[]>(url);
  }

  updateAssignments(request: UpdateZoneInspectionAssignmentsRequest): Observable<void> {
    return this.http.post<void>(`${this.apiBase}/organizations/zone-inspection-assignments`, request);
  }
}